<template>
  <div class="fullpage">
    <div class="searchBox" v-if="type == 0">
      <el-input style="width: 30%;margin-right: 10px;" v-model="frameNum" :placeholder="`${$t('menu.FrameNumber')}/${$t('menu.EngineNumber')}`"></el-input> 
      <el-button plain @click="querySearch">{{ $t('menu.search') }}</el-button>
    </div>
    <div class="basicInformation">
      <div class="title">
        <div class="name">{{$t('menu.Basicinformation')}}</div>
      </div>
      <div class="Info" v-if="type == 2 || type == 1">
        <div class="infoItem">
          <div class="name">{{ $t('menu.ClaimNumber') }}</div>
          <div class="infoData">{{ carInfo.co.claimNumber }}</div>
        </div>
        <div class="infoItem" v-if="type == 2">
          <div class="name">{{ $t('menu.State') }}</div>
          <div class="infoData">{{staue.filter(e=>e.id == carInfo.co.status).length>0 ?staue.filter(e=>e.id == carInfo.co.status)[0].name:carInfo.co.status}}</div>
        </div>
        <div class="infoItem" v-if="carInfo.co.toCoNumber!==null&&carInfo.co.toCoNumber!==undefined">
          <div class="name">{{ $t('menu.gongchangsuopdh') }}</div>
          <div class="infoData">{{carInfo.co.toCoNumber}}</div>
        </div>
        
      </div>
      <div class="Info">
        <div class="infoItem">
          <div class="name">{{ $t('menu.ProductName') }}</div>
          <div class="infoData" v-if="type == 0">{{  filterCarModels(carInfo.co.params!==undefined? carInfo.co.params.mcVersion.mcSeriesModel:'') }}</div>
          <div class="infoData" v-if="type == 2 || type == 1">{{ iszh == 'zh' ? carInfo.co.motorName :  carInfo.co.motorNameEn}}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.FrameNumber') }}</div>
          <div class="infoData">{{ carInfo.co.chassisNumber || carInfo.co.vin }}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.EngineNumber') }}</div>
          <div class="infoData">{{ carInfo.co.engineNo }}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.SaleDate') }}</div>
          <div class="infoData" >{{ /\s/.test(carInfo.co.sellingTime) ? carInfo.co.sellingTime.split(' ')[0] : carInfo.co.sellingTime }}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.Customer') }}</div>
          <div class="infoData">{{ carInfo.co.ownerName	}}</div>
          <div v-if="showInfo">——</div>
        </div>
        <div class="infoItem">
          <div class="name">{{ $t('menu.cldasclss') }}</div>
          <div class="infoData" v-if="type!==2">{{ carInfo.co.sellingStoreName }}</div>
           <!-- <div class="infoData" v-if="type==2">{{ carInfo.co.sellingStoreName }}</div> -->
          <div v-if="showInfo">——</div>
        </div>
      </div>
    </div>
    <div class="compensateInfo">
      <div class="title">
        <div class="name">{{ $t('menu.ClaimInformation') }}</div>
      </div>
      <div v-if="showInfo" class="beforeShowInfo">
        {{showinfoMsg}}
      </div>
      <div v-else>
        <div class="infoItemOne">
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.ClaimType') }}
            </div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.claimType" :placeholder="`${$t('menu.ClaimType')}`" clearable v-if="type == 0 || type == 1">
                <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in titleList" :key="index"></el-option>
              </el-select>
              <div v-if="type == 2 ">
                {{(carInfo.co.claimType!=='' && carInfo.co.claimType!==null) ? ( iszh == 'zh' ? titleList.filter(e=>e.dictValue == carInfo.co.claimType)[0].dictLabel : titleList.filter(e=>e.dictValue == carInfo.co.claimType)[0].dictLabelEn) : ''}}
              </div>
            </div>
          </div>
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Failurecategory') }}
            </div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.faultType" :placeholder="`${$t('menu.Failurecategory')}`" filterable clearable v-if="type == 0 || type == 1">
                <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in titleLista" :key="index"></el-option>
              </el-select>
              <div v-if="type == 2 ">
                {{(carInfo.co.faultType!=='' && carInfo.co.faultType!==null) ? ( iszh == 'zh' ? titleLista.filter(e=>e.dictSort == carInfo.co.faultType)[0].dictLabel : titleLista.filter(e=>e.dictSort == carInfo.co.faultType)[0].dictLabelEn) : ''}}
              </div>
            </div>
          </div>
          <div class="infoItemOneItem">
            <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Mileage')}}(km)</div>
            <div class="inputBox">
              <el-input v-model="carInfo.co.mileage" :placeholder="$t('menu.Enter')" v-if="type == 0 || type == 1"></el-input>
              <div v-if="type == 2">{{carInfo.co.mileage}}</div>
            </div>
          </div>
          <div class="infoItemOneItem" v-if="type == 2">
            <div class="name">{{ $t('menu.ClaimAmount') }}</div>
            <div class="inputBox" style="color: red;">{{  carInfo.co.claimAmount }}</div>
          </div>
          <div v-if="tup!=='2'" class="infoItemOneItem">
            <div class="infoItemOneItem" style="width: 100%;" v-if="type == 0 || type == 1">
            <div class="name"><span style="color: red;">*</span> {{$t('menu.Applicationtime')}}</div>
            <div class="inputBox">
              <el-date-picker v-model="carInfo.co.applicationTime" type="date" value-format="yyyy-MM-dd" :placeholder="$t('menu.Expected')"></el-date-picker>
            </div>
          </div>
          <div class="infoItemOneItem" style="width: 100%;" v-if="type == 2">
            <div class="name">{{ $t('menu.ApplicationTime') }}</div>
            <div class="inputBox">{{carInfo.co.applicationTime}}</div>
          </div>
          </div>
         <!-- <div v-if="tup!=='2'" class="infoItemOneItem">
           <div class="infoItemOneItem" style="width: 100%;" v-if="type == 0 || type == 1">
            <div class="name"><span style="color: red;">*</span> {{$t('menu.Country1')}}</div>
            <div class="inputBox">
              <el-select v-model="carInfo.co.applyingDealerAreaId" :placeholder="`${$t('menu.Country')}`" filterable clearable v-if="type == 0 || type == 1">
                <el-option v-for="item in gb" :key="item.dictValue" :label="bbca(item.dictLabel)" :value="item.dictValue"></el-option>
              </el-select>
            </div>
          </div>
          <div class="infoItemOneItem" v-if="type == 2" style="width: 100%;">
            <div class="name">{{$t('menu.Country1')}}</div>
            <div class="inputBox" style="width: 100%;">
           
            {{ bbcaa( carInfo.co.applyingDealerAreaId) }}
            </div>
          </div>
         </div> -->
        </div>
        <div class="infoItemTwo">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{
            $t('menu.ProblemDescription')
          }}</div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.faultDescription"
            v-if="type == 0 || type == 1" ></el-input>
          <div v-if="type == 2">{{carInfo.co.faultDescription}}</div>
        </div>
        <div class="infoItemTwo" v-if="tup!=='2'">
          <!-- <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Analysis') }}
          </div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.causeAnalysis"
            v-if="type == 0 || type == 1"></el-input>
          <div v-if="type != 0 && type != 1">{{carInfo.co.causeAnalysis}}</div> -->
        </div>
        <div class="infoItemTwo">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{ $t('menu.Solution') }}
          </div>
          <el-input type="textarea" :rows="2"  :placeholder="$t('menu.Enter')" v-model="carInfo.co.repairPlan"
            v-if="type == 0 || type == 1"></el-input>
          <div v-if="type != 0 && type != 1">{{carInfo.co.repairPlan}}</div>
        </div>
        <div class="infoItemTwo"  v-if="carInfo.co.status==59">
          <div class="name"><span style="color: red;">*</span>{{ $t('menu.Reasons') }}
          </div>
         
          <div >{{carInfo.co.remarks          }}</div>
        </div>
      </div>
    </div>
    <div class="compensateDetail" v-if="!showInfo">
      <div class="title">
        <div class="nameList">
          <div class="nameItem" :class="active == 1 ? 'acti' : ''" @click="changeActive(1)">{{ $t('menu.ClaimDetails')}}</div>
          <!-- <div class="nameItem" :class="active == 2 ? 'acti' : ''" @click="changeActive(2)">{{ $t('menu.Attachment') }}</div> -->
          <!-- <div class="nameItem" :class="active == 3 ? 'acti' : ''" @click="changeActive(3)" v-if="type != 0">{{ $t('menu.ClaimRecord') }}</div>
          <div class="nameItem" :class="active == 4 ? 'acti' : ''" @click="changeActive(4)" v-if="type != 0">{{ $t('menu.OperationRecord') }}</div> -->
        </div>
      </div>
      <!-- 明细 -->
      <div class="detail" v-if="active == 1">
        <div class="typeTitle">
          <div class="name"><span style="color: red;">*</span>  {{$t('menu.Claimedpart')}}</div>
        </div>
        <el-button plain @click="addParts" v-if="type == 0 || type == 1" style="margin-bottom: 10px;">{{ $t('menu.AddTo') }}</el-button>
        <el-table  empty-text=" " :data="carInfo.coParts.filter((v) => v.deleted==false)" border style="width: 100%" >
          <el-table-column  type="index" :label="$t('menu.NO')" width="50"></el-table-column>
          <el-table-column v-if="tup!=='2'" prop="partNumber" :label="$t('menu.PartCode')" min-width="120"></el-table-column>
          <el-table-column v-else prop="partNumber" :label="$t('menu.PartCode')" min-width="120"></el-table-column>
          <el-table-column prop="partName" :label="$t('menu.PartName')" min-width="120">
            <template slot-scope="scope">{{ iszh=='zh' ? scope.row.partName : scope.row.partNameEn }}</template>
          </el-table-column>
          <el-table-column :label="$t('menu.Currency')" min-width="80">
            <template slot-scope="scope">{{ currency }}</template>
          </el-table-column>
          <el-table-column  :label="$t('menu.UnitPrice')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <div v-if="tup!=='2'">
                {{ currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd }}
              </div>
              <div v-else>{{ scope.row.salePrice }}</div>
            </template>
          </el-table-column>
           
          <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" min-width="120" v-if="type == 2"></el-table-column>
          <el-table-column :label="$t('menu.Quantity')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <el-input v-model="scope.row.minPurchaseQuantity"  @input="sumMoney(scope.row)"></el-input>
            </template>
          </el-table-column>
          
            <el-table-column :label="$t('menu.shigonglex')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
             
               <el-select v-model="scope.row.workType" @change="xzlx($event,scope.row)" placeholder="请选择">
                
                <el-option    :label=" $t('menu.weix') " :value="0"> </el-option>
                <el-option   :label="$t('menu.genghuan')" :value="1"> </el-option>
              </el-select>
              
            </template>
          </el-table-column>
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" min-width="80" v-if="type == 2"></el-table-column>
              <el-table-column prop="workType" :label="$t('menu.shigonglex')" min-width="80" v-if="type == 2">
                <template slot-scope="scope">
                  <div v-if="scope.row.workType=='0'"> {{ $t('menu.weix') }} </div>
                  <div v-if="scope.row.workType=='1'">{{ $t('menu.genghuan') }} </div>
               
              
            </template>
                
              </el-table-column>
          <el-table-column :label="$t('menu.peijianjine')" min-width="80" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <div v-if="tup!=='2'">
                 {{Number(scope.row.salePrice) * Number(scope.row.minPurchaseQuantity) | NumFormat}}
                <!-- {{Number(currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd) * Number(scope.row.minPurchaseQuantity) | NumFormat}} -->
              </div>
              <div v-else>
                {{Number(scope.row.salePrice) * Number(scope.row.minPurchaseQuantity) | NumFormat}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="amount" :label="$t('menu.peijianjine')" min-width="80" v-if="type == 2"></el-table-column>
          <el-table-column  :label="$t('menu.LaborCost')" min-width="80">
            <template slot-scope="scope">
              <div v-if="type !== '2'">
                <div v-if="scope.row.workType==0">
                <!-- {{scope.row.repairLabourPrice}} -->
                 <el-input v-model="scope.row.labourAmount"  ></el-input>
              </div>
              <div v-else>
                 <!-- {{scope.row.replaceLabourPrice}} -->
                  <el-input v-model="scope.row.labourAmount"  ></el-input>
              </div>
              </div>


              <div v-if="type == 2">
                {{ scope.row.labourAmount }}
              </div>
            </template>
           </el-table-column>
          <el-table-column prop="approvedQuantity" :label="$t('menu.yitonggshul')"  v-if="type == 2"></el-table-column>
          <el-table-column prop="paidQuantity" :label="$t('menu.yipeifushul')"  v-if="type == 2"></el-table-column>
         
         
           
           <el-table-column prop="needClaim" :label="$t('menu.shenhezhuangt')" min-width="80" v-if="type == 2">
              <template slot-scope="scope"> 
                <div v-if="scope.row.needClaim=='0'">{{ $t('menu.Rejected') }}</div>
                 <div v-else-if="scope.row.needClaim=='1'">{{ $t('menu.Approved') }}</div>
                  <div v-else>{{$t('menu.PendingReview') }}</div>
              </template>
           </el-table-column>
          <el-table-column :label="$t('menu.Operation')" width="150" v-if="type == 0 || type == 1">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deleteCoparts(scope.$index, scope.row)">{{ $t('menu.Delete') }}</el-button>
            </template>
          </el-table-column>

        </el-table>
        <div style="padding: 10px 0;" v-if="type == 0 || type == 1">{{ $t('menu.Amount') }}： <span style="color: red;">{{amount |NumFormat}}</span></div>
        <div style="padding: 10px 0;" v-if="type == 2">{{ $t('menu.peijianzioee') }}： <span style="color: red;margin-right: 30px;">{{carInfo.coPartAmount |NumFormat}}</span>
        {{ $t('menu.gongshifzonge') }}： <span style="color: red;">{{carInfo.co.labourClaimAmount |NumFormat}}</span>
        </div>
       
        <!-- <div class="typeTitle">{{ $t('menu.ClaimForLaborHour') }}</div>
        <el-table :data="coLabours" border style="width: 80%">
          <el-table-column prop="labourName" label="名称" min-width="80"></el-table-column>
          <el-table-column prop="name" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="unitPrice" :label="$t('menu.StandardLaborCost')" min-width="80"></el-table-column>
          <el-table-column prop="labourHours" :label="$t('menu.LaborHours')" min-width="80"></el-table-column>
          <el-table-column prop="labourCost" :label="$t('menu.LaborCost')" min-width="80"></el-table-column>
          <el-table-column prop="needClaim" :label="$t('menu.SupportClaims')" min-width="80"></el-table-column>
        </el-table>
        <div style="padding: 10px 0;">{{ $t('menu.SubTotal') }}： <span style="color: red;">$ 200.00</span></div>
        <div class="typeTitle">
          <div class="name" v-if="type == 0 || type == 1">其他费用</div>
          <div class="name" v-if="type != 0 && type != 1">自定义</div>
          <el-button plain v-if="type == 0 || type == 1">{{ $t('menu.AddTo') }}</el-button>
        </div>
        <el-table :data="tableData" border style="width: 60%">
          <el-table-column prop="name" label="" min-width="80" v-if="type == 0 || type == 1"></el-table-column>
          <el-table-column prop="name" label="名称" min-width="120"></el-table-column>
          <el-table-column prop="name" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="name" label="费用" min-width="80"></el-table-column>
          <el-table-column prop="name" :label="$t('menu.SupportClaims')" min-width="80"></el-table-column>
        </el-table>
        <div style="padding: 10px 0;">{{ $t('menu.SubTotal') }}： <span style="color: red;">$ 200.00</span></div> -->

        <!-- 附件 -->
        <!-- <div class="detail" v-if="active == 2"> -->
        <div class="typeTitle">
          <div class="name"><span style="color: red;" v-if="type == 0 || type == 1">*</span> {{$t('menu.Attachment')}}</div>
        </div>
        <el-upload action="#" :multiple="true"   list-type="icon" :on-preview="handlePictureCardPreview" :http-request="uploadFile" :before-upload="beforeAvatarUpload" 
          :file-list="fileList" v-if="type == 0 || type == 1">
          <el-button size="small" type="primary">{{$t('menu.Uploadfiles')}}</el-button>
          <div slot="tip" class="el-upload__tip">{{$t('menu.Note10M')}}</div>

          <div slot="file" slot-scope="{file}">
              <img @click="filedialogVisiblea(file)" style="width: 100px;height: 100px;border-radius: 15px;" class="el-upload-list__item-thumbnail" :src="showFile(file)">
              <span class="el-upload-list__item-actions">
                <a :href="file.url" style="text-decoration:auto;color: #000;cursor: pointer;"  >
                  {{ $t('menu.Download') }}
                </a>
               <span style="cursor: pointer;"  @click="handleRemove(file)" >
                
                {{ $t('menu.Delete') }}
               </span>
               <!-- <span v-if="!disabled" @click="handleRemove(file)" class="el-upload-list__item-delete">
                 <i class="el-icon-delete"></i>
               </span> -->
             </span>
            </div>


        </el-upload>
        <div  v-if="type == 2" style="display: flex;">
          <div v-if="carInfo.co.imageData!=='[]'" v-for="(item,index) in JSON.parse(carInfo.co.imageData)" :key="index"  style="border: 1px solid #f2f2f2; padding: 10px;margin-right: 10px;">
     
          <img @click="filedialogVisiblea(item)" style="width: 100px;height: 100px;border-radius: 15px;" class="el-upload-list__item-thumbnail" :src="showFile(item)">
            
              <div style="text-align: center;">
                <div>{{ item.name }}</div>
               <div>
                <a :href="item.url" style="text-decoration:auto;color: #000;cursor: pointer;"  >
                  {{ $t('menu.Download') }}
                </a>
              </div>
              </div>
            

          </div>
        </div>
      </div>
      <!-- 索赔记录 -->
      <div class="detail" v-if="active == 3">
        <el-table  empty-text=" " :data="carInfo.hisCos" border style="width: 100%">
          <el-table-column prop="claimNumber" :label="$t('menu.ClaimNumber')" min-width="80"></el-table-column>
          <el-table-column :label="$t('menu.Vehicle')" min-width="80">
            <template slot-scope="scope">{{ iszh == 'zh' ? scope.row.motorName : scope.row.motorNameEn}}</template>
          </el-table-column>
          <el-table-column prop="claimType" :label="$t('menu.ClaimType')" min-width="80">
            <template slot-scope="scope">
              {{iszh == 'zh' ? titleList.filter(e=>e.dictValue ==scope.row.claimType)[0].dictLabel : titleList.filter(e=>e.dictValue == scope.row.claimType)[0].dictLabelEn}}
            </template>
          </el-table-column>
          <el-table-column prop="mileage" :label="$t('menu.Mileage')" min-width="80"></el-table-column>
          <el-table-column prop="currencyType" :label="$t('menu.Currency')" min-width="80"></el-table-column>
          <el-table-column prop="claimAmount" :label="$t('menu.ClaimAmount')" min-width="80"></el-table-column>
          <el-table-column prop="applicationTime" :label="$t('menu.ApplicationTime')" min-width="80"></el-table-column>
        </el-table>
      </div>
      <!-- 操作记录 -->
      <div class="detail" v-if="active == 4">
        <el-table  empty-text=" " :data="carInfo.coOperationLogs" border style="width: 100%">
          <el-table-column prop="actionTime" :label="$t('menu.Timecaozuo')"  min-width="80"></el-table-column>
          <el-table-column prop="actionUserName" :label="$t('menu.Operator')" min-width="80"></el-table-column>
          <el-table-column prop="actionEvent" :label="$t('menu.OperationContent')" min-width="80"></el-table-column>
          <el-table-column prop="remarks" :label="$t('menu.Remarks')" min-width="80"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="subBox" v-if="!showInfo">
      <!-- <div class="totalMoney">合计： <span style="color: red;">$ 20.23</span></div> -->
      <div class="butto">
        
        <el-button type="primary" @click="coAuditByDealera(20)" v-if="type == 2 && carInfo.co.status == 10">{{$t('menu.tijiaojhishushene')}}</el-button>
        <el-button type="primary" @click="dkl()" v-if="type == 2 && carInfo.co.status == 10">{{$t('menu.bohui')}}</el-button>
          <el-button type="primary" @click="jspk(20)" v-if="type == 2 && carInfo.co.status == 20">{{$t('menu.jishubanpdduan')}}</el-button>
          <el-button type="primary" @click="gclp(carInfo.co.id)" v-if="type == 2 && carInfo.co.status == 20">{{$t('menu.xianggongclp')}}</el-button>
          <el-button type="primary" @click="gclp(carInfo.co.id)" v-if="type == 2 && carInfo.co.status == 50">{{$t('menu.xianggongclp')}}</el-button>
          <el-button type="primary" @click="gclp(carInfo.co.id)" v-if="type == 2 && carInfo.co.status == 55">{{$t('menu.xianggongclp')}}</el-button>
        <el-button type="primary" @click="submit" v-if="type == 0">{{$t('menu.Submitsuopei')}}</el-button>
        <el-button type="primary" @click="updateMyCo" v-if="type == 1"> {{ $t('menu.Save') }} </el-button>
        <el-button plain @click="modify" v-if="type == 2 && carInfo.co.status == 10">{{ $t('menu.Modify') }}</el-button>
        <el-button plain @click="cancelMyCo" v-if="type == 2 && carInfo.co.status == 10">{{$t('menu.Cancelsuopei') }}</el-button>
        <el-button type="primary" v-if="type == 2 && carInfo.co.status == 60" @click="modify">{{ $t('menu.Modify') }}</el-button>
        <el-button type="primary" v-if="type == 2 && carInfo.co.status == 59" @click="modify">{{ $t('menu.Modify') }}</el-button>
        <el-button plain @click="cancelMyCo" v-if="type == 2 && carInfo.co.status == 59">{{$t('menu.Cancelsuopei') }}</el-button>
        <el-button  v-if="type == 0 || type == 1" @click="cancel"> {{ $t('menu.Cancel') }} </el-button>
      </div>
    </div>

    <!--添加配件  -->
    <el-dialog :title="$t('menu.AddParts')" :visible.sync="dialogVisiblePart" v-if="dialogVisiblePart" width="800px" @close="ccac" :close-on-click-modal="false">
      <div class="partBox">
        <div class="searchBox">
          <el-input v-model="searchKey" :placeholder=" $t('menu.Enter') "></el-input>
          <el-button plain @click="pageQueryPartList">{{ $t('menu.search') }}</el-button>
        </div>
        <el-table  empty-text=" " :data="partList" border style="width: 100%" @selection-change="handleSelectionChange" height="500">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column v-if="tup!=='2'" prop="partCode" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column v-else prop="partCode" :label="$t('menu.PartCode')" min-width="80"></el-table-column>
          <el-table-column v-if="tup!=='2'" :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partName2 }}
            </template>
          </el-table-column>
           <el-table-column v-else :label="$t('menu.PartName')" min-width="80">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partName2 }}
            </template>
          </el-table-column>
          <el-table-column v-if="tup!=='2'" :label="$t('menu.Partcategory')" min-width="80">
            <template slot-scope="scope">
              {{ scope.row.categoryId  }}
            </template>
          </el-table-column>
           <el-table-column v-else :label="$t('menu.Partcategsory')" min-width="80">
            <template slot-scope="scope">
              {{ scope.row.categoryId  }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('menu.Currency')" min-width="80">
            <template slot-scope="scope">{{ currency }}</template>
          </el-table-column>
          <el-table-column v-if="tup!=='2'" :label="$t('menu.UnitPrice')" min-width="80">
            <template slot-scope="scope">{{ currency == 'CNY' ? scope.row.purchasePriceCny : currency == 'EUR' ? scope.row.purchasePriceEur : scope.row.purchasePriceUsd }}</template>
          </el-table-column>
            <el-table-column v-else :label="$t('menu.UnitPrice')" min-width="80">
            <template slot-scope="scope">{{ scope.row.salePrice  }}</template>
          </el-table-column>
        </el-table>
        <div class="buttBox">
          <el-button type="primary" @click="getpartList">{{$t('menu.Confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 文件预览 -->
    <el-dialog :visible.sync="filedialogVisible" :title="srtitle" v-if="filedialogVisible"  width="70%" style="">
      <yl v-if="typ == 'pdf'" :url="filedialogImageUrl" :typ="'pdf'"></yl>
      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->
       <!-- <iframe v-if="typ == 'pdf'"  frameborder="0" :src="videoUrl"  width="100%" height="800px" /> -->
      <yl v-if="typ == 'xlsx'" :url="filedialogImageUrl" :typ="'xlsx'"></yl>
      <yl v-if="typ == 'docx'" :url="filedialogImageUrl" :typ="'docx'"></yl>
      <yl v-if="typ == 'excel'" :url="filedialogImageUrl" :typ="'excel'"></yl>
      <img style="width: 100%;" v-if="typ == 'png' || typ == 'jpg' || typ == 'jepg'|| typ == 'jpeg'|| typ == 'JPG'" :src="filedialogImageUrl" alt="">
      <iframe v-if="typ !== 'png' && typ !== 'jpg' && typ !== 'jepg'&& typ !== 'jpeg'&& typ !== 'JPG' && typ !== 'mp4' && typ !== 'txt' && typ !== 'pdf'&& typ !== 'xlsx'&& typ !== 'docx'&& typ !== 'excel'"
        :src='filedialogImageUrl' style="width: 100%; height: 70vh" frame />
    </el-dialog>
    <!-- 提交成功弹窗 -->
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false">
      <div class="img"><img src="../../assets/images/ck_tg.png" alt=""></div>
      <div style="width: 100%;text-align: center;margin: 30px 0">{{$t('menu.Success')}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="continueToApply">{{$t('menu.Continue')}}</el-button>
        <el-button type="primary" @click="viewOrders">{{$t('menu.Viewtheorder')}}</el-button>
      </span>
    </el-dialog>
     <!-- 驳回弹窗 -->
    <el-dialog :visible.sync="ialogVisiblecd" width="30%" :title="$t('menu.chushenjuj')">
        <div style="padding: 20px;">
          <div>{{$t('menu.shucujujyy')}}：</div>
      <div>
        <el-input
          type="textarea"
          :rows="4"
        
          v-model="bhyx">
        </el-input>

      </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="continueToApply">{{ $t('menu.Cancel') }}</el-button>
        <el-button type="primary" @click="bhqrr(59)"> {{ $t('menu.Confirm') }}  
</el-button>
      </span>
    </el-dialog>
     <!-- 技术判断 -->
    <el-dialog :visible.sync="ialogVisibljspd" width="1000px" :title="$t('menu.jishupand')">
        <div style="padding: 20px;overflow-x: auto;">
       <el-table :data="carInfo.coParts" border style="width: 100%"  height="300">
         
          <el-table-column  prop="partNumber" :label="$t('menu.PartCode')" width="180"></el-table-column>
         
          <el-table-column  :label="$t('menu.PartName')" width="180">
            <template slot-scope="scope">
              {{ iszh == 'zh' ? scope.row.partName : scope.row.partNameEn }}
            </template>
          </el-table-column>
          
          <el-table-column  :label="$t('menu.shigonglex')" width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.workType=='1'">{{ $t('menu.genghuan') }}</div>
               <div v-if="scope.row.workType=='0'">{{ $t('menu.weix') }}</div>
              
            </template>
          </el-table-column>
          
          <el-table-column :label="$t('menu.Quantity')" width="80" prop="quantity"> </el-table-column>
          <el-table-column :label="$t('menu.suopk')" >
            <template slot-scope="scope">
             <div style="display: flex;">
               <el-radio v-model="scope.row.needClaim" label="1">{{ $t('menu.zhic') }}</el-radio>
              <el-radio v-model="scope.row.needClaim" label="0">{{ $t('menu.nozhic') }}</el-radio>
             </div>
             </template>
          </el-table-column>
           <el-table-column  :label=" $t('menu.dadijishupd')" >
                    <template slot-scope="scope">
                     <el-input
               
              
                  v-model="scope.row.technicalEvaluationReport">
                </el-input>
           
             </template>
          </el-table-column>
           
        </el-table>

        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="continueToApply"> {{ $t('menu.Cancel') }} </el-button>
        <el-button type="primary" @click="jspd(29)"> {{ $t('menu.Confirm') }}  </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pageQueryPartList,submitCo2Platform,dealerAreaOfRetailerlist, submisaveCoDto,pageQueryVin,coAuditByDealer, cancelMyCo,getInfo, upload, pageQuerySa,listAccType,querytype,gbquerytype,submitCoDto,submitCoDtoaa,mcVehicleOfDealerLista,partRetailerOfDealer,pageQueryParta,listMcSeriesModels,getMyCoDto,updateMyCo } from '../../api/api'
import yl from '../../components/yl' //发票
export default {
   components: {
    yl
   
  },
  data () {
    return {
       typ:'',
      type: 0, //类型（0-新增，1-修改，2-详情(审核中、已取消、待接收)  3-重新提交）
      iszh:sessionStorage.getItem('i18n'),
      titleList:[],
      bhyx:'',
      ialogVisiblecd:false,
      ialogVisibljspd:false,
        options: [{
          value: '0',
          label:this.$t('menu.weix')
        }, {
          value: '1',
          label: this.$t('menu.genghuan')
        }, ],
      cartypelist:[],
      active: 1,
      dialogVisiblePart: false,
      centerDialogVisible: false,
      currency:'', //币种
      showInfo:true,
      showinfoMsg:this.$t('menu.Pleaseentertheframe'),
      searchKey: '',
      amount:0,
      frameNum: '', //发动机号
      carList: [],
      carInfo: {
        co:{
          claimType: '', //索赔类型
          mileage: '', //行驶里程
          applicationTime: '', //经销商申请时间
          faultDescription: '', //故障描述
          causeAnalysis:'', //原因分析
          repairPlan: '', //解决方案
        },
        coParts: [],//索赔配件
      },
      coLabours: [
        {
          labourName: '',//名称
          //币种
          unitPrice: '',//标准工时费
          labourHours: '',//工时
          labourCost: '',//工时费
          needClaim: '',//支持索赔
        }
      ],//索赔工时
      partList: [],//配件列表
      filedialogImageUrl: '',//文件预览地址
      titleLista:[],
      filedialogVisible: false,
      fileList: [],//上传文件列表
      selectpart:[],
      gb:[],
      aeera: [],
      srtitle:'',
      acbc:[],
      staue: [
      {
          name: this.$t('menu.All'),
          num: 0,
          id: ''
        },
        {
          name: this.$t('menu.PendingReview'),
          num: 0,
          id: '10'
        },
        {
          name: this.$t('menu.daijishushenhe'),
          num: 0,
          id: '20'
        },
       
      
        {
          name:this.$t('menu.pfzl'),
          num: 0,
          id: '50'
        },
         {
          name: this.$t('menu.ypfl'),
          num: 0,
          id: '55'
        },
        {
          name:  this.$t('menu.dkhqrl'),
          num: 0,
          id: '59'
        },
        {
          name: this.$t('menu.Cancelled'),
          num: 0,
          id: '60'
        },
      ],
      jxc:[],
      acclist:[],
      tup:'1',
      inle:'zh'
    }
  },
  filters:{
    NumFormat(value) {
      if (!value) return '0.00';
      // 将数值截取，保留两位小数
      value = Number(value).toFixed(2);
      // 获取整数部分
      const intPart = Math.trunc(value);
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      let floatPart = '.00';
      // 将数值截取为小数部分和整数部分
      const valueArray = Number(value)
          .toString()
          .split('.');
      if (valueArray.length === 2) {
          // 有小数部分
          floatPart = valueArray[1].toString(); // 取得小数部分
          return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    }

  },
 
  mounted () {
    this.acc()
    // this.infoaa()
    this.getQuerytype()
    this.aeer()
    this.gbquerytype()
    this.gbquerytypea()
    this.listMcSeriesModel()
    this.tup = sessionStorage.getItem('platform')
     let a = sessionStorage.getItem('i18n')
    this.inle = a
    if(this.$route.query.type) {
      this.type= this.$route.query.type
      if(this.type == 2){
        this.showInfo = false
        this.getMyCoDto(this.$route.query.id)
      }
    }
    sessionStorage.setItem('spxq',1)
  },
  watch:{
    
    fileList(newV,oldV){
      if(JSON.stringify(newV) != this.carInfo.co.imageData){
        let v =[]
        this.fileList.forEach((e,i)=>{
          let  bbb ={
            name:e.name,
            url:e.url,
            deleted:false
          }
         v.push(bbb)
        })
        this.carInfo.co.imageData = JSON.stringify(v)
      }
    },
    '$route': {
      handler (newVal, old) {
        console.log(old,88888888);
        if(old === undefined){
        } else {
          location.reload()
        }
        
      },
      immediate: true
    }
  },
  methods: {
     sxtitle(e){
      let a =''
        // console.log(11,JSON.parse(e.categoryNameEn));
        
      if(this.inle=='zh'){
        a=e.categoryName
      }
    if(this.inle=='en'){
      if(e.categoryNameEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.categoryNameEn)
     
        a=c.en
      }else{
        a=e.categoryNameEn
      }
      

      }
      if(this.inle=='de'){
         if(e.categoryNameEn.indexOf(":") !== -1){
             let d =JSON.parse(e.categoryNameEn)
        a=d.de
         } else{
        a=e.categoryNameEn
      } 
         
      
      }
      return a

    },
    dkl (){
      this.ialogVisiblecd=true
    },
   async bhqrr(e){
      
       let param = new URLSearchParams();
    let da='?approval='+e+'&coId=' +this.carInfo.co.id+'&remarks='+this.bhyx
      
      const { data: res } = await coAuditByDealer( param,da  );
        if(res.code=='500'){
            this.$message.error(res.msg)
        }else{
          this.continueToApply()
        }
    },
     async coAuditByDealera(e){
      let param = new URLSearchParams();
    let da='?approval='+e+'&coId=' +this.carInfo.co.id
      
      const { data: res } = await coAuditByDealer( param,da  );
        if(res.code=='500'){
            this.$message.error(res.msg)
        }else{
          this.continueToApply()
        }
    },
    async gclp(row){
     
      this.$router.push({
        path: "/ClaimApplyb",
        query: {
          id: row,
          type: 1,
        },
      });






      //  let param = new URLSearchParams();
   
      // const { data: res } = await submitCo2Platform( this.carInfo.co.id  );
      //   if(res.code=='500'){
      //       this.$message.error(res.msg)
      //   }else{
      //     this.continueToApply()
      //   }
    },
    jspk(){
      this.ialogVisibljspd=true
    },
         jspd(){
             let cbca  = []
      let dat =this.carInfo
          cbca=this.carInfo.coParts
     cbca.forEach((e,i)=>{
        if(e.partId==null&&e.partId==undefined){
          e.partId = e.id
          cbca[i].id=null
        }
        e.quantity = e.minPurchaseQuantity
      })
      let bbcin = []
      cbca.forEach(zzz=>{
      
        bbcin.push(zzz.id)
      })
      this.acbc.forEach(zz=>{
        
          if(bbcin.indexOf(zz.id)==-1){
           
           
              cbca.push(zz)
          }
        })
      
        cbca.forEach((ez,iii)=>{
           if(ez.needClaim=='1'){
               cbca[iii].approvedQuantity=ez.quantity
            }
        })
      dat.coParts=cbca
      console.log(this.carInfo,cbca);
      
      submisaveCoDto(dat).then(res=>{
        if(res.data.code == 200){
          let ccdf=this.carInfo.coParts
          let a = 0
          ccdf.forEach(zzc=>{
            if(zzc.needClaim==1){
              
            }else{
              a++
            }
          })
          if(a>0){
            this.coAuditByDealera(59)
          }else{
            this.coAuditByDealera(50)
          }
         
        } else {
          this.$message.error(res.data.msg)
        }
      })
         },
    
    async acc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
   this.infoaa()

    },
    async infoaa () {
      let param = new URLSearchParams();
      const { data: res } = await getInfo(param)
      

      this.acclist.forEach(e => {
          // console.log(1222222222222222222231,res.uesr);
          if (e.id == res.user.dealers[0].accTypeIdLs) {
          
         this.currency=e.currencyType
              // console.log(122222222222222222223123,this.currency);
              

          // console.log(123123, res.user.dealers[0].accTypeIdSh, e.id, e.currencyType);
        }
        
      })
    },
    showFile(file){
      console.log(456,file)
      
      const isImage = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length)
      if(isImage=='png'||isImage=='jpg'||isImage=='jpeg'){
        return file.url;
      }
      if(isImage=='pdf'){
        return require('@/assets/images/pdf.jpeg')
      }
      if(isImage=='txt'){
        return require('@/assets/images/txt.webp')
      }
      if(isImage=='doc'||isImage=='docx'){
        return require('@/assets/images/word.jpeg')
      }
      if(isImage=='xls'||isImage=='xlsx'){
        return require('@/assets/images/xlsx.webp')
      }

    },
    base64Encode(e){
  var rv;
  rv = encodeURIComponent(e);
  rv = unescape(rv);
  rv = window.btoa(rv);
  return rv;
},
    filedialogVisiblea(str){
    
      this.srtitle=str.name
      let b = str.name.substring(str.name.lastIndexOf(".") + 1, str.name.length);
  console.log(str,b);
      // this.aurl='https://view.officeapps.live.com/op/view.aspx?src=https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.filedialogImageUrl = str.url
      this.typ=b


 
      this.filedialogVisible = true
    },
    changeActive (e) {
      this.active = e
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();
      const { data: res } = await listMcSeriesModels(param);
      this.cartypelist = res.data;
    },
    filterCarModels(m){
      if(m == '') return ''
      if(this.cartypelist.some(e=>e.id == m)){
        return this.iszh == 'zh' ? this.cartypelist.filter(e=>e.id == m)[0].seriesModel : this.cartypelist.filter(e=>e.id == m)[0].seriesModelEn
      } else {
        return m
      }
    },
    
    deleteCoparts(index,row){
      let a  = this.carInfo.coParts[index]
      a.deleted=true
      this.acbc.push(a)
      this.carInfo.coParts.splice(index,1)
      this.amount=0
      
      this.carInfo.coParts.forEach(e=>{
         if(this.tup!=='2'){
      this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      
        }else{
          this.amount = this.amount + Number( e.salePrice ) * Number(e.minPurchaseQuantity)
      
        }
       })
    },
    xzlx(e,z){
      console.log(e,z,this.carInfo.coParts);
      let a = this.carInfo.coParts
      
      a.forEach((zz,i)=>{
        if(zz.partId==z.partId){
         a[i].workType=e
          
        }
      })
      this.carInfo.coPart=a
      console.log( this.carInfo.coParts);
      
    },
    sumMoney(z){
      this.amount = 0
      let a = this.carInfo.coParts
      this.carInfo.coParts=[]
      a.forEach((e,i)=>{
        if(e.id == z.id){
          this.$set(a[i], "minPurchaseQuantity", e.minPurchaseQuantity);
          // a[i].minPurchaseQuantity=e.minPurchaseQuantity
        }
        if(this.tup!=='2'){
      this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      
        }else{
          this.amount = this.amount + Number( e.salePrice ) * Number(e.minPurchaseQuantity)
      
        }
        })
      this.carInfo.coParts=a
      console.log( this.carInfo.coParts);
      
     
    },
    //车架号查询
    querySearch () {
      let params = 'searchValue=' + this.frameNum
      mcVehicleOfDealerLista(params).then(res=>{
        if(res.data.total !== 0){
          this.carInfo.co= {...this.carInfo.co,...res.data.rows[0]}
          this.carInfo.co.engineNo = this.carInfo.co.engineNumber
          this.carInfo.co.sellingTime = this.carInfo.co.salesDate
          this.carInfo.co.ownerName = this.carInfo.co.customerName
          this.carInfo.co.imageData = ''
          delete this.carInfo.co.status
          this.showInfo = false
        }else{
          this.showinfoMsg = this.$t('menu.Novehiclemodelinformation') 
        }
      })
    },
    ccac(){
      console.log(123, this.searchKey);
      this.searchKey=''
      console.log(123, this.searchKey);
    },
    //我的理赔单详情
    getMyCoDto (id) {
      getMyCoDto('coId=' + id).then(res => {
        this.carInfo = res.data.data
        this.carInfo.coParts.forEach((e,i)=>{
          this.$set(e, "minPurchaseQuantity",  e.quantity);
        
      })
      console.log(1221112,this.carInfo);
       this.pageQueras()
      if(res.data.data.co.imageData!=='[]'){
        this.fileList = JSON.parse(res.data.data.co.imageData)
      }
        
      })
    },
     async  pageQueras () {
      let param = new URLSearchParams();
      let mcSeriesModelId 
      if(this.carInfo.co.params){
        mcSeriesModelId = this.carInfo.co.params.mcVersion.mcSeriesModel
      } else {
        
        mcSeriesModelId = this.carInfo.co.mcSeriesModelId
      }
      let searchKey =this.searchKey 
      if(this.tup=='2'){
        
         const { data: res } = await partRetailerOfDealer(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey,
        '',
        ''
      );
      let a =[]
     
      res.rows.forEach(z=>{
        if(z.status=='1'){
           z.workType=0
           z.partRetailerId=z.id
           z.deleted=false
          a.push(z)
        }
         
       
      })
      this.partList = a
         this.carInfo.coParts.forEach((e,i)=>{
         
           
          this.partList.forEach(z=>{
           
            
            if(e.partId==z.partId){
               this.$set(e, "repairLabourPrice",  z.repairLabourPrice);
          this.$set(e, "replaceLabourPrice",  z.replaceLabourPrice);
          this.$set(e, "salePrice",  z.salePrice);
            }
          })
         
        
      })
      console.log(2222,this.carInfo.coParts);
      
      }else{
        const { data: res } = await partRetailerOfDealer(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey,
        '',
        1
      );
      let a =[]
     
      res.rows.forEach(z=>{
        if(z.status=='1'){
           z.workType=0
           z.partRetailerId=z.id
           z.deleted=false
          a.push(z)
        }
         
       
      })
      this.partList = a
         this.carInfo.coParts.forEach((e,i)=>{
         
           
          this.partList.forEach(z=>{
           
            
            if(e.partId==z.partId){
               this.$set(e, "repairLabourPrice",  z.repairLabourPrice);
          this.$set(e, "replaceLabourPrice",  z.replaceLabourPrice);
          this.$set(e, "salePrice",  z.salePrice);
            }
          })
         
        
      })
      }
     
    },
    NumFormat2(value) {
      if (!value) return '0.00';
      // 将数值截取，保留两位小数
      value = Number(value).toFixed(2);
      // 获取整数部分
      const intPart = Math.trunc(value);
      // 整数部分处理，增加,
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      // 预定义小数部分
      let floatPart = '.00';
      // 将数值截取为小数部分和整数部分
      const valueArray = Number(value)
          .toString()
          .split('.');
      if (valueArray.length === 2) {
          // 有小数部分
          floatPart = valueArray[1].toString(); // 取得小数部分
          return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    },
    //提交
    submit () {
      if(this.carInfo.coParts.length<1){
        this.$message({
          message: '请添加配件',
          type: 'warning'
        });
        return
      }
      this.carInfo.coParts.forEach((e,i)=>{
          if(this.tup!=='2'){
             e.partId = e.id
        this.carInfo.coParts[i].id=null
        e.quantity = e.minPurchaseQuantity
      e.amount =  Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      
        }else{
         
        this.carInfo.coParts[i].id=null
        e.quantity = e.minPurchaseQuantity
          e.amount = Number( e.salePrice ) * Number(e.minPurchaseQuantity)
      
        }
       
        
        // e.amount=Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
      })
   
      
      let data= {
        co:{
          applicationTime:this.carInfo.co.applicationTime != '' ? this.carInfo.co.applicationTime  +' 00:00:00' : '',
          causeAnalysis:this.carInfo.co.causeAnalysis,
          claimType:this.carInfo.co.claimType,
          engineNo:this.carInfo.co.engineNo,
          faultDescription:this.carInfo.co.faultDescription,
          imageData:this.carInfo.co.imageData,
          mileage:this.carInfo.co.mileage,
          repairPlan:this.carInfo.co.repairPlan,
          vin:this.carInfo.co.chassisNumber,
          faultType:this.carInfo.co.faultType,
          // applyDealerAreaId:this.carInfo.co.applyDealerAreaId,
          applyingDealerAreaId:this.carInfo.co.applyingDealerAreaId,
          partPaymentMethod:'part'
        },
        coParts:this.carInfo.coParts,
      }
      submitCoDto(data).then(res=>{
        console.log(111111111,res);
        
        if(res.data.code == 200){
          this.centerDialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //修改 tijiao
    updateMyCo(){
      // updateMyCo().then(res=>{

      // })
      // this.carInfo.co.applicationTime=this.carInfo.co.applicationTime != '' ? this.carInfo.co.applicationTime  +' 00:00:00' : ''
      let cbca  = []
      let dat =this.carInfo
          cbca=this.carInfo.coParts
     cbca.forEach((e,i)=>{
        if(e.partId==null&&e.partId==undefined){
          e.partId = e.id
          cbca[i].id=null
        }
        e.quantity = e.minPurchaseQuantity
      })
      let bbcin = []
      cbca.forEach(zzz=>{
      
        bbcin.push(zzz.id)
      })
      this.acbc.forEach(zz=>{
        
          if(bbcin.indexOf(zz.id)==-1){
              cbca.push(zz)
          }
        })
      dat.coParts=cbca
      console.log(this.carInfo,cbca);
      
      submitCoDto(dat).then(res=>{
        if(res.data.code == 200){
          this.centerDialogVisible = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    modify(){
      this.type = 1
      if(this.carInfo.co.imageData!='[]'){
         this.fileList= JSON.parse( this.carInfo.co.imageData );
      }

      this.amount=this.carInfo.coPartAmount
      this.carInfo.coParts.forEach((e,index)=>{
        if(e.quantity){
          e.minPurchaseQuantity = e.quantity
          this.$set(this.carInfo.coParts,index,e)
          if(this.currency == 'CNY'){
            e.purchasePriceCny = e.unitPrice
            this.$set(this.carInfo.coParts,index,e)
          } else if(this.currency == 'EUR'){
            e.purchasePriceEur = e.unitPrice
            this.$set(this.carInfo.coParts,index,e)
          } else {
            e.purchasePriceUsd = e.unitPrice
            this.$set(this.carInfo.coParts,index,e)
          }
        }
      })
    },
    // 继续申请
    continueToApply(){
      location.reload(); //刷新当前页面
    },
    // 查看订单
    viewOrders(){
      this.$router.push("/Sales");
    },
    //取消申请
    cancelMyCo () {
      let params = 'coId=' + this.$route.query.id + '&remarks='
      cancelMyCo(params).then(res => {
        console.log(res,'取消申请');
        if(res.data.code==200){
          this.$message({
          message: 'success',
          type: 'success'
        });
        this.$router.go(0)
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    //取消
    cancel(){
      this.$router.push('/Sales')
    },
    
    getpartList(){
      this.amount=0
      if(this.selectpart.length>0){
        this.selectpart.forEach((z,zz)=>{
          this.$set(z, "workType",  1);
        })
      }
      this.carInfo.coParts = [...this.carInfo.coParts,...this.selectpart]
      this.carInfo.coParts.forEach(e=>{
        if(this.tup!=='2'){
        //  this.amount = this.amount + Number(this.currency == 'CNY' ? e.purchasePriceCny : this.currency == 'EUR' ? e.purchasePriceEur : e.purchasePriceUsd) * Number(e.minPurchaseQuantity)
          console.log(1);
          if(e.partNumber==undefined){
             e.partNumber=e.partCode
          e.partNameEn=e.partName2
          }
         
           this.amount = this.amount + Number(e.salePrice) * Number(e.minPurchaseQuantity)
        }else{
          console.log(2);
          
           this.amount = this.amount + Number(e.salePrice) * Number(e.minPurchaseQuantity)
      
        }
       })
      this.dialogVisiblePart = false
    },
    
    //添加配件
    addParts () {
          this.searchKey=''
      this.pageQueryPartList()
      this.dialogVisiblePart = true
    },
    async  pageQueryPartList () {
      let param = new URLSearchParams();
      let mcSeriesModelId 
      if(this.carInfo.co.params){
        mcSeriesModelId = this.carInfo.co.params.mcVersion.mcSeriesModel
      } else {
        
        mcSeriesModelId = this.carInfo.co.mcSeriesModelId
      }
      let searchKey =this.searchKey 
      if(this.tup=='2'){
        
         const { data: res } = await partRetailerOfDealer(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey,
        '',
        ''
      );
      let a =[]
      console.log(123,res);
      res.rows.forEach(z=>{
        if(z.status=='1'){
           z.workType=0
           z.partRetailerId=z.id
           z.deleted=false
          a.push(z)
        }
         
       
      })
      this.partList = a
      }else{
      //    const { data: res } = await pageQueryParta(
      //   param,
      //   1,
      //   100,
      //   mcSeriesModelId,
      //   searchKey
      // );
      // let a =[]
      // res.data.list.forEach(z=>{
      //   if(z.deleted==false){
      //     a.push(z)
      //   }
      // })
      // this.partList = a
        const { data: res } = await partRetailerOfDealer(
        param,
        1,
        100,
        mcSeriesModelId,
        searchKey,
         '',
        1
      );
      let a =[]
      console.log(123,res);
      res.rows.forEach(z=>{
        if(z.status=='1'){
           z.workType=0
           z.partRetailerId=z.id
           z.deleted=false
          a.push(z)
        }
         
       
      })
      this.partList = a
      }
     
    },
    handleSelectionChange(val) {
      this.selectpart = val
    },
    
    pageQuerySa () {
      pageQuerySa().then(res => {

      })
    },
    //表头添加红色必填符号*
    renderHeader (h, { column, $index }) {
      return h(
        'div',
        [
          h('span', { style: 'color:red' }, '* '),
          h('span', column.label)
        ]
      )
    },
    async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area/%20/', sessionStorage.getItem('userId'));
      this.gb = res.data
    },
    async gbquerytypea () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer/%20/', sessionStorage.getItem('userId'));
      this.jxc = res.data
    },
    bbca (e) {
      let a = ''
      let b = this.aeera
      b.forEach(z => {
        if (z.dictLabel == e) {
          a = z
        }
      })
      let bb = ''
      if (this.iszh == 'zh') {
        bb = a.dictLabel
      } else {
        bb = a.dictLabelEn
      }
      return bb
    },
    bbcaa (e) {
 
      
      let a = ''
      let b = this.gb
  
      b.forEach(z => {
        console.log(456456,z.dictCode,e);
        if (z.dictValue == e) {
          if (this.iszh == 'zh') {
        a = z.dictLabel
       
      } else {
        a = z.dictLabelEn
      }
        }
      })
    
     
      return a
    },
    async aeer () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(param, 'area');
      this.aeera = res.data
    },
    beforeAvatarUpload(file){
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt2M;
    },
    uploadFile (file) {
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('category', file.file.type)
      upload(formdata).then(res => {
        if (res.data.code == '200') {
          this.$message.success('上传成功')
          let obj = {
            name:file.file.name,
            url:res.data.data
          }
          this.fileList.push(obj)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList.forEach((e,i)=>{
        if(e.name == file.name){
          this.fileList.splice(i,1)
        }
      })
    },
    handlePictureCardPreview (file) {
      // if(file.url){
      //   this.filedialogImageUrl = file.url;
      // } else {
      //   this.fileList.filter(e=>e.name == file.file.name)[0].url
      // }
    },
    
    checkStaus(e){
      if(e == 10){
        return '待业务接收'
      } else if (e ==20){
        return '审核中'
      } else if (e ==29){
        return '审核中'
      } else if (e ==30){
        return '审核中'
      } else if (e ==39){
        return '审核中'
      } else if (e ==40){
        return '审核中'
      } else if (e ==49){
        return '审核中'
      } else if (e ==50){
        return this.$t('menu.Approved')
      } else if (e ==59){
        return '已驳回'
      } else if (e ==60){
        return '已取消'
      } else {
        return e
      }
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_co_claim_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleList.push(i)
          })
        }
      })
      querytype( params, 't_co_fault_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleLista.push(i)
          })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.fullpage {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  .searchBox{
    display: flex;
    width: 100%;
    align-items: center;  
    :deep(.el-input){
      width: 400px;
      margin-right: 20px;
    }
  }

  .title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #dcdfe6;
    margin: 10px 0;
    font-size: 18px;

    .name {
      border-left: 3px solid #409eff;
      padding-left: 10px;
      height: 22px;
      line-height: 22px;
    }
  }

  .basicInformation {
    width: 100%;
    margin-top: 20px;

    .Info {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;

      .infoItem {
        width: 30%;
        height: 70px;
        display: flex;
        flex-direction: column;

        .name {
        margin: 10px 0;
        color: #909399;
        }

        .infoData {}
      }
    }
  }

  .compensateInfo {
    width: 100%;
    margin-top: 20px;
    .beforeShowInfo{
      color: red;
      padding-left: 20px;
    }

    .infoItemOne {
      margin-top: 30px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-left: 10px;

      .infoItemOneItem {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-bottom: 20px;
        .name {
          margin: 10px 0;
          color: #909399;
        }

        .inputBox {
          width: 70%;
        }
      }
    }

    .infoItemTwo {
      width: 100%;
      padding-left: 10px;
      padding-bottom: 20px;

      .name {
        margin: 10px 0;
        color: #909399;
      }
    }
  }
/deep/.el-upload-list__item{
  width: fit-content;
}
  .compensateDetail {
    width: 100%;
    margin-top: 20px;

    .title {
      .nameList {
        border-left: 3px solid #409eff;
        padding-left: 10px;
        height: 22px;
        line-height: 22px;
        display: flex;

        .nameItem {
          margin-right: 40px;
          cursor: pointer;
        }

        .acti {
          color: #409eff;
        }
      }
    }

    .detail {
      width: 100%;
      padding-bottom: 30px;

      :deep(.el-upload-list__item.is-success .el-upload-list__item-status-label){ 
        position: static;
      }
      :deep(.el-upload-list__item){
        display: flex;
        align-items: center;
      }
      :deep(.el-icon-close){
        position: static;
      }

      .typeTitle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
      }

      .uploadFiles {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        width: 300px;

        .bluecolor {
          color: #409eff;
        }

        .redcolor {
          color: red;
        }
      }
    }
  }

  .subBox {
    height: 60px;
    //border-top: 1px solid #dcdfe6;
    //border-bottom: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .partBox {
    border-top: 1px solid #dcdfe6;
    padding: 20px;

    .searchBox {
      margin-bottom: 20px;

      /deep/.el-input {
        width: 50%;
      }

      /deep/.el-button {
        margin-left: 20px;
      }
    }

    .buttBox {
      width: 100%;
      text-align: center;
      padding: 30px;
    }

  }
  .img{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  :deep(.el-textarea__inner){
    font-family: inherit;
  }
}

/deep/.el-dialog__body {
  padding: 0 !important;
}
:deep(.el-upload-list.el-upload-list--picture) {
  display: none !important; //这里设置原有的缩略图视图隐藏
}

.el-upload-list.el-upload-list--picture.show {
  display: block !important; //展示自定义
}

</style>